import React from 'react'
import { Form, VerticalNav } from 'hhsoig-design-system-core'
import { ErrorBoundary } from '../../components/errorBoundary'
import {scroller, animateScroll} from 'react-scroll'
import withBackButtonProtection from '../../components/withBackButtonProtection'
import withDocTitle from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'
import css from './OpDivReferral.module.css'

export class OpDivReferralForm extends React.Component {
  state = { selectedNavId: 'opdiv' }

  /*
   * This function is called when user clicks a Navigation option.
   * Want to set 'selectedNavId' to the given 'id'
   * so the VerticalNav display is updated to highlight the option.
   */
  onNavClick = (event, id) => {
    id === 'opdiv'
    ? animateScroll.scrollToTop({duration:500, smooth: true}) 
    : scroller.scrollTo(id, {duration:500, smooth: true} )
    this.setState({ selectedNavId: id })
  }

  render() {
    return (
      <ErrorBoundary>
        <main className="ds-l-container">
          <div className="ds-l-row">
            <div className="ds-l-col">
              <h1 className="ds-u-margin-bottom--0">Web complaint</h1>
              <p className="ds-u-margin-top--0 ds-u-margin-bottom--5 ds-u-font-size--h3">
                Operating division referral
              </p>
            </div>
          </div>
          <div className="ds-l-row">
            <div className="ds-l-sm-col--12 ds-l-md-col--4">
              {
                <VerticalNav
                  className={css.navLocation}
                  selectedId={this.state.selectedNavId}
                  onLinkClick={this.onNavClick}
                  items={[
                    {
                      id: 'opdiv',
                      label: 'Operating division',
                      url: 'javascript:void(0)'
                    },
                    {
                      id: 'poc',
                      label: 'Point of contact',
                      url: 'javascript:void(0)'
                    },
                    {
                      id: 'complaint',
                      label: 'Complaint',
                      url: 'javascript:void(0)'
                    },
                    {
                      id: 'attachments',
                      label: 'Attachments',
                      url: 'javascript:void(0)'
                    },
                    {
                      id: 'subjects',
                      label: 'Subjects',
                      url: 'javascript:void(0)'
                    }
                  ]}
                />
              }
            </div>
            <div className="ds-l-sm-col--12 ds-l-md-col--8">
              <Form schema={this.props.schema} />
            </div>
          </div>
        </main>
      </ErrorBoundary>
    )
  }
}
export default withRecaptcha(
  withBackButtonProtection(withDocTitle(OpDivReferralForm))
)
